import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={<>Custom end-to-end IOS and Android app development</>}
        description={
          <>
            Crafting beautiful <b>mobile apps</b> with battle-tested technology
          </>
        }
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="blue-purple"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            Rumble Fish mobile app developers are masters of crafting apps that
            impress even the most demanding users.
            <br />
            We’ve worked with global brands to help them design, develop, and
            maintain their mobile solutions in line with the latest standards
            and trends.
            <br />
            Our experts know how to take your mobile app concept and elevate it
            elevate it both technologically and visually, turning it into a
            beautiful piece of mobile software.
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
